import { DiagnosticTestProperties } from "modules/TaxonomyModule/consts";

export const diagnosticTestPropsKeys: string[] = Object.values({
  ...DiagnosticTestProperties
});

export const diagnosticTestRelationsKeys: string[] = [];
